import { useEffect, useRef, useState } from 'react'

import _ from 'lodash'

export default function useLarge({
  children,
  itemsPerRow,
  width,
  gap = 6,
}: {
  children: React.ReactNode | React.ReactNode[]
  itemsPerRow: number
  width: number
  gap?: number
}) {
  const colSpan = 12 / itemsPerRow
  const scrollContainer = useRef(null)
  const items = Array.isArray(children) ? children : [children]
  const gapPx = gap * 4
  const gapCount = Math.floor(11 / colSpan)
  const itemWidth = ((width - gapPx * gapCount) * colSpan) / 12
  const containerWidth = itemWidth * items.length + gapPx * (items.length - 1)
  const [itemIndex, setItemIndex] = useState(0)
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(false)

  const scroll = (direction: 1 | -1) => {
    const newItemIndex = Math.max(
      0,
      Math.min(items.length, itemIndex + direction)
    )
    setItemIndex(newItemIndex)
    scrollContainer.current.scrollTo({
      left: newItemIndex * (itemWidth + gapPx),
      behavior: 'smooth',
    })
  }

  const checkArrowVisibility = () => {
    const el = scrollContainer.current
    const isAtScrollStart = el.scrollLeft === 0
    const isAtScrollEnd = el.scrollLeft + el.offsetWidth === el.scrollWidth
    if (isAtScrollStart) {
      setShowLeftArrow(false)
    } else {
      setShowLeftArrow(true)
    }
    if (isAtScrollEnd) {
      setShowRightArrow(false)
    } else {
      setShowRightArrow(true)
    }
  }

  const onScroll = React.useMemo(
    () => _.debounce(checkArrowVisibility, 200),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    const el = scrollContainer.current
    checkArrowVisibility()
    el.addEventListener('scroll', onScroll)
    return () => {
      el.removeEventListener('scroll', onScroll)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    showLeftArrow,
    showRightArrow,
    scroll,
    scrollContainer,
    containerWidth,
    items,
    itemWidth,
  }
}
